import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCodeNavigate from "components/router/useCodeNavigate";
import { SidebarContent } from "components/search/buckets/SearchWithFilter/common/SearchResultLayout/style";
import Content from "components/search/results/ChapterResults/Content";
import { ClinicalParagraph } from "components/search/results/ChapterResults/interface";
import { historyService } from "context";
import { useStoreContext } from "context/StoreProvider";
import { useEffect, useState } from "react";
import { Button, Nav, Row, Tab, TabContainer, Table } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useParams } from "react-router-dom";
import {
  codesystemsEndpointName,
  fetchApi,
  getApiEndpoint,
  historyString
} from "utils";

import AdmHistoryList from "../AdmHistoryList";

const HistoryList = () => {
  const { view } = useParams();
  const { state } = useStoreContext();
  const { codeSystem } = state;
  const navigate = useCodeNavigate();

  const [history, setHistory] = useState<ClinicalParagraph[]>([]);

  let smallScreen = isMobile || window.innerWidth < 992;

  const updateWindowDimensions = () => {
    smallScreen = isMobile || window.innerWidth < 992;
  };
  window.addEventListener("resize", updateWindowDimensions);

  const fetchCodeInfo = async (codes: string[]) => {
    const endpoint = getApiEndpoint(codeSystem as string, codes.join("+"));
    const data = await fetchApi(endpoint);

    return data;
  };

  const isAdm = codeSystem === codesystemsEndpointName.adm;

  useEffect(() => {
    if (
      !codeSystem ||
      view !== historyString ||
      codeSystem === codesystemsEndpointName.adm
    )
      return;

    const storedHistory = historyService.getCodeSystemHistory(codeSystem);

    if (!history) return;
    // check if all stored already are in state
    if (
      storedHistory.every((c) => history.some((h) => h.codeValue === c)) &&
      history.length === storedHistory.length
    ) {
      history.sort((a: ClinicalParagraph, b: ClinicalParagraph) => {
        return (
          storedHistory.indexOf(a.codeValue) -
          storedHistory.indexOf(b.codeValue)
        );
      });
      return;
    }

    fetchCodeInfo(storedHistory).then((data) => {
      if (!data || !Array.isArray(data) || data.length === 0) return;

      // ensure data is sorted the same as storedHistory
      const sortedData = data.toSorted(
        (a: ClinicalParagraph, b: ClinicalParagraph) => {
          return (
            storedHistory.indexOf(a.codeValue) -
            storedHistory.indexOf(b.codeValue)
          );
        }
      );
      for (const item of sortedData) {
        item.hierarchyLevel = 2;
      }
      setHistory(sortedData);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeSystem, view]);

  const removeCode = (code: string) => {
    historyService.removeFromHistory(codeSystem as string, code);
    setHistory(history.filter((c) => c.codeValue !== code));
  };

  const [key, setKey] = useState("0");

  const renderContent = () => {
    if (isAdm) {
      return <AdmHistoryList />;
    }

    if (history.length > 0 && codeSystem) {
      return (
        <TabContainer
          activeKey={key}
          onSelect={(k: string | null) => setKey(k || "0")}
        >
          <Row>
            <SidebarContent $isAdm={isAdm} $size={"sm"}>
              <Nav>
                <Table striped hover className="p-0">
                  <thead>
                    <tr>
                      <th>Kode</th>
                      <th>Fjern</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history.map(
                      (paragraph: ClinicalParagraph, index: number) => (
                        <tr
                          onMouseEnter={() => setKey(`${index}`)}
                          key={`history-list-item-${index}`}
                        >
                          <td
                            onClick={() =>
                              navigate.toCode(codeSystem, paragraph.codeValue)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              {paragraph.codeValue}
                            </span>{" "}
                            {paragraph.nameNorwegian || paragraph.nameEnglish}
                          </td>
                          <td>
                            <Button
                              variant="none"
                              onClick={() => removeCode(paragraph.codeValue)}
                            >
                              <FontAwesomeIcon icon={faClose} />
                            </Button>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </Nav>
            </SidebarContent>
            {!smallScreen && (
              <SidebarContent className={`d-flex `} $isAdm={isAdm} $size={"sm"}>
                <Tab.Content>
                  {history.map(
                    (paragraph: ClinicalParagraph, index: number) => (
                      <Tab.Pane
                        eventKey={`${index}`}
                        key={`history-item-details-${index}`}
                      >
                        <div className="m-3" />
                        <Content
                          paragraph={paragraph}
                          codeSystem={codeSystem}
                          activeCode={false}
                        />
                      </Tab.Pane>
                    )
                  )}
                </Tab.Content>
              </SidebarContent>
            )}
          </Row>
        </TabContainer>
      );
    }

    return <div>Ingen besøkte {isAdm ? "kodeverk" : "koder"}</div>;
  };

  return renderContent();
};

export default HistoryList;
